(function (app) {

    app.provider("userRegistrationApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.getUserRegistration = function (userRegistrationId) {
                            return complianceHubApiGateway.get("/UserRegistrations/" + userRegistrationId);
                        };

                        service.getUserRegistrationByToken = function (token) {
                            return complianceHubApiGateway.get("/UserRegistrations/Token/" + token);
                        };

                        service.getAllIncompleteUserRegistrations = function () {
                            return complianceHubApiGateway.getArray("/UserRegistrations/All");
                        }

                        service.getAllIncompleteUserRegistrationsForTransactionGroup = function (transactionGroupId) {
                            return complianceHubApiGateway.getArray("/UserRegistrations/ForTransactionGroup/" + transactionGroupId);
                        }

                        service.completeUserRegistration = function (userRegistration) {
                            return complianceHubApiGateway.put("/UserRegistrations/" + userRegistration.Id, userRegistration);
                        }

                        service.resendUserRegistration = function (userRegistrationId) {
                            return complianceHubApiGateway.put("/UserRegistrations/Resend/" + userRegistrationId);
                        }

                        service.createUserRegistration = function (userRegistration) {
                            return complianceHubApiGateway.post("/UserRegistrations/", userRegistration);
                        }

                        service.deleteUserRegistration = function (userRegistrationId) {
                            return complianceHubApiGateway.delete("/UserRegistrations/Delete/" + userRegistrationId);
                        }

                        return service;
                    }
                ];
            }
        ]);
})(window.app); // jshint ignore:line